import { BaseScreen } from "./BaseScreen";

import type { AuthScreenEvents } from "./components/AuthScreenEvents";

export class AuthScreen extends BaseScreen {

    private root!: HTMLElement;

    constructor(
        private readonly events: AuthScreenEvents
    ) {

        super();

    }

    public override mount(): void {

        super.mount();

        this.root =
            this.buildRoot();

    }

    public override update(): void {

        super.update();

        const newRoot =
            this.buildRoot();

        this.root.replaceWith(
            newRoot
        );

        this.root =
            newRoot;

    }

    public override unmount(): void {

        super.unmount();

    }

    public getRoot(): HTMLElement {

        return this.root;

    }

    // =========================
    // BUILD
    // =========================

    private buildRoot(): HTMLElement {

        const root =
            document.createElement("div");

        root.className =
            "auth-container";

        const card =
            document.createElement("div");

        card.className =
            "auth-card";

        // -------------------------
        // Logo
        // -------------------------

        const logoLink =
            document.createElement("a");

        logoLink.href =
            "https://fr.bezbolu.pro";

        const logo =
            document.createElement("img");

        logo.src =
            "/icons/logo.png";

        logo.className =
            "auth-logo";

        logoLink.appendChild(
            logo
        );

        card.appendChild(
            logoLink
        );

        // -------------------------
        // Welcome
        // -------------------------

        const welcome =
            document.createElement("div");

        welcome.className =
            "auth-welcome";

        welcome.innerHTML = `
            Вітаємо вас на платформі для вивчення французької для українців.
            <br/>
            <b>Що ви хочете зробити?</b>
        `;

        card.appendChild(
            welcome
        );

        // -------------------------
        // Subscribe button
        // -------------------------

        const subscribe =
            document.createElement("a");

        subscribe.className =
            "subscribe-button";

        subscribe.href =
            "https://fr.bezbolu.pro/#pricing";

        subscribe.textContent =
            "Хочу підписатися";

        card.appendChild(
            subscribe
        );

        // -------------------------
        // Login card
        // -------------------------

        const loginCard =
            document.createElement("div");

        loginCard.className =
            "auth-login-card";

        const title =
            document.createElement("div");

        title.className =
            "auth-login-title";

        title.textContent =
            "Вже підписані?";

        loginCard.appendChild(
            title
        );

        const email =
            document.createElement("input");

        email.id =
            "auth-email";

        email.type =
            "email";

        email.placeholder =
            "Введіть email, на який ви зареєструвалися";

        loginCard.appendChild(
            email
        );

        const button =
            document.createElement("button");

        button.textContent =
            "Увійти";

        button.addEventListener(
            "click",
            () => this.submit()
        );

        email.addEventListener(
            "keydown",
            e => {

                if (e.key === "Enter") {
                    this.submit();
                }

            }
        );

        loginCard.appendChild(
            button
        );

        const error =
            document.createElement("div");

        error.id =
            "auth-error";

        error.className =
            "auth-error";

        loginCard.appendChild(
            error
        );

        card.appendChild(
            loginCard
        );

        root.appendChild(
            card
        );

        return root;

    }

    // =========================
    // ACTIONS
    // =========================

    private async submit(): Promise<void> {

        const input =
            this.root.querySelector<HTMLInputElement>(
                "#auth-email"
            );

        const error =
            this.root.querySelector<HTMLElement>(
                "#auth-error"
            );

        const email =
            input?.value.trim() ?? "";

        if (!email) {

            if (error) {
                error.textContent =
                    "Введіть email";
            }

            return;

        }

        await this.events.submit(
            email
        );

    }

}